// ============================================
// DONNÉES CENTRALISÉES POUR JOVAL
// Multi-société / Multi-agence
// ============================================

// --- SOCIÉTÉS ---
export const societes = [
  { id: 1, nom: 'JOVAL', type: 'Marchés publics', siret: '123 456 789 00012' },
  { id: 2, nom: 'JOVAL CONSEIL', type: 'Clients privés', siret: '987 654 321 00034' },
];

// --- AGENCES ---
export const agences = [
  { id: 1, nom: 'Marseille', ville: 'Marseille', adresse: '45 rue de la République, 13001 Marseille', telephone: '04 91 00 00 00', responsable: 'Marc Duval' },
  { id: 2, nom: 'Aix-en-Provence', ville: 'Aix-en-Provence', adresse: '12 cours Mirabeau, 13100 Aix-en-Provence', telephone: '04 42 00 00 00', responsable: 'Sophie Laurent' },
];

// --- INGÉNIEURS ---
export const ingenieurs = [
  { id: 1, nom: 'Duval', prenom: 'Marc', initiales: 'MD', email: 'marc.duval@joval.fr', telephone: '06 10 00 00 01', agenceId: 1, role: 'Directeur technique', couleur: '#2563EB' },
  { id: 2, nom: 'Laurent', prenom: 'Sophie', initiales: 'SL', email: 'sophie.laurent@joval.fr', telephone: '06 10 00 00 02', agenceId: 1, role: 'Ingénieure chargée d\'affaires', couleur: '#7C3AED' },
  { id: 3, nom: 'Bernard', prenom: 'Thomas', initiales: 'TB', email: 'thomas.bernard@joval.fr', telephone: '06 10 00 00 03', agenceId: 1, role: 'Ingénieur chargé d\'affaires', couleur: '#059669' },
  { id: 4, nom: 'Petit', prenom: 'Julie', initiales: 'JP', email: 'julie.petit@joval.fr', telephone: '06 10 00 00 04', agenceId: 2, role: 'Ingénieure chargée d\'affaires', couleur: '#DC2626' },
  { id: 5, nom: 'Moreau', prenom: 'Antoine', initiales: 'AM', email: 'antoine.moreau@joval.fr', telephone: '06 10 00 00 05', agenceId: 2, role: 'Ingénieur chargé d\'affaires', couleur: '#D97706' },
];

// --- CODES MISSION ---
export const codesMission = [
  { code: 'DIAG', label: 'Diagnostic' },
  { code: 'CTB', label: 'Contrôle Technique Bâtiment' },
  { code: 'SSI', label: 'Sécurité Incendie' },
  { code: 'ACOU', label: 'Acoustique' },
  { code: 'THER', label: 'Thermique' },
  { code: 'STR', label: 'Structure' },
  { code: 'VRD', label: 'Voirie et Réseaux Divers' },
  { code: 'ENV', label: 'Environnement' },
  { code: 'ACC', label: 'Accessibilité' },
  { code: 'AMO', label: 'Assistance Maîtrise d\'Ouvrage' },
];

// --- CLIENTS ---
// Un client peut travailler avec plusieurs sociétés
export const clients = [
  {
    id: 1, nom: 'Bouygues Immobilier', type: 'professionnel', marchePublic: false,
    societesIds: [2],
    adresse: '3 boulevard Gallieni, 92130 Issy-les-Moulineaux', ville: 'Issy-les-Moulineaux',
    contactTechnique: { nom: 'Pierre Martin', email: 'p.martin@bouygues-immo.com', telephone: '01 55 38 00 00' },
    contactFacturation: { nom: 'Marie Dupont', email: 'm.dupont@bouygues-immo.com', telephone: '01 55 38 00 01' },
    contactAdministratif: { nom: 'Jean Lefèvre', email: 'j.lefevre@bouygues-immo.com', telephone: '01 55 38 00 02' },
  },
  {
    id: 2, nom: 'Mairie de Marseille', type: 'public', marchePublic: true,
    societesIds: [1],
    adresse: 'Hôtel de Ville, 13001 Marseille', ville: 'Marseille',
    contactTechnique: { nom: 'Alain Roche', email: 'a.roche@marseille.fr', telephone: '04 91 55 00 00' },
    contactFacturation: { nom: 'Nathalie Blanc', email: 'n.blanc@marseille.fr', telephone: '04 91 55 00 01' },
    contactAdministratif: { nom: 'Nathalie Blanc', email: 'n.blanc@marseille.fr', telephone: '04 91 55 00 01' },
  },
  {
    id: 3, nom: 'Nexity Provence', type: 'professionnel', marchePublic: false,
    societesIds: [1, 2],
    adresse: '25 avenue du Prado, 13006 Marseille', ville: 'Marseille',
    contactTechnique: { nom: 'Lucie Garnier', email: 'l.garnier@nexity.fr', telephone: '04 91 77 00 00' },
    contactFacturation: { nom: 'Paul Fabre', email: 'p.fabre@nexity.fr', telephone: '04 91 77 00 01' },
    contactAdministratif: { nom: 'Paul Fabre', email: 'p.fabre@nexity.fr', telephone: '04 91 77 00 01' },
  },
  {
    id: 4, nom: 'Métropole Aix-Marseille', type: 'public', marchePublic: true,
    societesIds: [1],
    adresse: '58 boulevard Charles Livon, 13007 Marseille', ville: 'Marseille',
    contactTechnique: { nom: 'François Morel', email: 'f.morel@ampmetropole.fr', telephone: '04 91 99 00 00' },
    contactFacturation: { nom: 'Claire Fontaine', email: 'c.fontaine@ampmetropole.fr', telephone: '04 91 99 00 01' },
    contactAdministratif: { nom: 'Claire Fontaine', email: 'c.fontaine@ampmetropole.fr', telephone: '04 91 99 00 01' },
  },
  {
    id: 5, nom: 'SCI Les Terrasses du Vieux Port', type: 'professionnel', marchePublic: false,
    societesIds: [2],
    adresse: '18 quai du Port, 13002 Marseille', ville: 'Marseille',
    contactTechnique: { nom: 'Robert Vidal', email: 'r.vidal@terrasses-vp.com', telephone: '04 91 33 00 00' },
    contactFacturation: { nom: 'Isabelle Roux', email: 'i.roux@terrasses-vp.com', telephone: '04 91 33 00 01' },
    contactAdministratif: { nom: 'Isabelle Roux', email: 'i.roux@terrasses-vp.com', telephone: '04 91 33 00 01' },
  },
  {
    id: 6, nom: 'Eiffage Construction Méditerranée', type: 'professionnel', marchePublic: false,
    societesIds: [1, 2],
    adresse: '110 avenue du 24 avril 1915, 13012 Marseille', ville: 'Marseille',
    contactTechnique: { nom: 'André Lemoine', email: 'a.lemoine@eiffage.com', telephone: '04 91 66 00 00' },
    contactFacturation: { nom: 'Sandrine Costa', email: 's.costa@eiffage.com', telephone: '04 91 66 00 01' },
    contactAdministratif: { nom: 'Sandrine Costa', email: 's.costa@eiffage.com', telephone: '04 91 66 00 01' },
  },
  {
    id: 7, nom: 'Département des Bouches-du-Rhône', type: 'public', marchePublic: true,
    societesIds: [1],
    adresse: '52 avenue de Saint-Just, 13004 Marseille', ville: 'Marseille',
    contactTechnique: { nom: 'Gérard Pons', email: 'g.pons@departement13.fr', telephone: '04 13 31 00 00' },
    contactFacturation: { nom: 'Mireille Aubert', email: 'm.aubert@departement13.fr', telephone: '04 13 31 00 01' },
    contactAdministratif: { nom: 'Mireille Aubert', email: 'm.aubert@departement13.fr', telephone: '04 13 31 00 01' },
  },
];

// --- DEVIS (importés depuis TIIME) ---
export const devis = [
  {
    id: 1, numero: 'DEV-2025-001', clientId: 1, ingenieurId: 1, societeId: 2, agenceId: 1,
    sourceTiime: true, tiimeId: 'TIIME-8842',
    designation: 'Diagnostic structure - Résidence Les Pins',
    adresse: '12 allée des Pins, 13008 Marseille', ville: 'Marseille',
    montantHT: 8500, statut: 'accepte',
    dateCreation: '2025-01-15', dateEnvoi: '2025-01-16', dateRelance: '2025-01-30', dateValidation: '2025-02-05',
    dateSyncTiime: '2025-02-05T14:30:00',
    echeancier: [
      { pourcentage: 50, label: 'Acompte à la commande', montant: 4250 },
      { pourcentage: 50, label: 'Solde à la remise du rapport', montant: 4250 },
    ],
    codeMission: 'DIAG',
    lignes: [
      { description: 'Prévisite sur site', quantite: 1, prixUnitaire: 500 },
      { description: 'Diagnostic structure bâtiment A', quantite: 1, prixUnitaire: 5000 },
      { description: 'Rapport d\'expertise', quantite: 1, prixUnitaire: 2000 },
      { description: 'Réunion de restitution', quantite: 1, prixUnitaire: 1000 },
    ],
  },
  {
    id: 2, numero: 'DEV-2025-002', clientId: 2, ingenieurId: 2, societeId: 1, agenceId: 1,
    sourceTiime: true, tiimeId: 'TIIME-8856',
    designation: 'Contrôle technique - Groupe scolaire Pasteur',
    adresse: 'Rue Pasteur, 13001 Marseille', ville: 'Marseille',
    montantHT: 22000, statut: 'accepte',
    dateCreation: '2025-01-20', dateEnvoi: '2025-01-22', dateRelance: null, dateValidation: '2025-02-10',
    dateSyncTiime: '2025-02-10T09:15:00',
    echeancier: [
      { pourcentage: 30, label: 'Phase études', montant: 6600 },
      { pourcentage: 40, label: 'Phase chantier', montant: 8800 },
      { pourcentage: 30, label: 'Réception', montant: 6600 },
    ],
    codeMission: 'CTB',
    lignes: [
      { description: 'Étude des plans et documents', quantite: 1, prixUnitaire: 3000 },
      { description: 'Visites de contrôle (estimées 8)', quantite: 8, prixUnitaire: 1500 },
      { description: 'Rapports intermédiaires', quantite: 3, prixUnitaire: 1000 },
      { description: 'Rapport final COPREC', quantite: 1, prixUnitaire: 4000 },
      { description: 'Attestation de conformité', quantite: 1, prixUnitaire: 3000 },
    ],
  },
  {
    id: 3, numero: 'DEV-2025-003', clientId: 3, ingenieurId: 3, societeId: 2, agenceId: 1,
    sourceTiime: true, tiimeId: 'TIIME-8901',
    designation: 'Mission SSI - Immeuble Grand Large',
    adresse: '8 boulevard du Littoral, 13002 Marseille', ville: 'Marseille',
    montantHT: 12000, statut: 'envoye',
    dateCreation: '2025-02-01', dateEnvoi: '2025-02-03', dateRelance: '2025-02-17', dateValidation: null,
    dateSyncTiime: '2025-02-17T11:00:00',
    echeancier: [
      { pourcentage: 50, label: 'Acompte à la commande', montant: 6000 },
      { pourcentage: 50, label: 'Solde à la remise du rapport', montant: 6000 },
    ],
    codeMission: 'SSI',
    lignes: [
      { description: 'Analyse réglementaire', quantite: 1, prixUnitaire: 2500 },
      { description: 'Préconisations SSI', quantite: 1, prixUnitaire: 5000 },
      { description: 'Plans de mise en sécurité', quantite: 1, prixUnitaire: 3000 },
      { description: 'Rapport SSI complet', quantite: 1, prixUnitaire: 1500 },
    ],
  },
  {
    id: 4, numero: 'DEV-2025-004', clientId: 5, ingenieurId: 4, societeId: 2, agenceId: 2,
    sourceTiime: true, tiimeId: 'TIIME-8920',
    designation: 'Étude acoustique - Résidence Vieux Port',
    adresse: '18 quai du Port, 13002 Marseille', ville: 'Marseille',
    montantHT: 6800, statut: 'brouillon',
    dateCreation: '2025-02-08', dateEnvoi: null, dateRelance: null, dateValidation: null,
    dateSyncTiime: '2025-02-08T16:45:00',
    echeancier: [
      { pourcentage: 100, label: 'Solde à la remise du rapport', montant: 6800 },
    ],
    codeMission: 'ACOU',
    lignes: [
      { description: 'Mesures acoustiques in situ', quantite: 1, prixUnitaire: 2800 },
      { description: 'Étude et modélisation', quantite: 1, prixUnitaire: 2500 },
      { description: 'Rapport d\'étude acoustique', quantite: 1, prixUnitaire: 1500 },
    ],
  },
  {
    id: 5, numero: 'DEV-2025-005', clientId: 6, ingenieurId: 5, societeId: 2, agenceId: 2,
    sourceTiime: true, tiimeId: 'TIIME-8935',
    designation: 'Étude thermique RE2020 - Lot C',
    adresse: 'ZAC des Fabriques, 13015 Marseille', ville: 'Marseille',
    montantHT: 15000, statut: 'envoye',
    dateCreation: '2025-02-05', dateEnvoi: '2025-02-06', dateRelance: null, dateValidation: null,
    dateSyncTiime: '2025-02-06T10:30:00',
    echeancier: [
      { pourcentage: 40, label: 'Acompte à la commande', montant: 6000 },
      { pourcentage: 30, label: 'Phase étude', montant: 4500 },
      { pourcentage: 30, label: 'Solde attestation', montant: 4500 },
    ],
    codeMission: 'THER',
    lignes: [
      { description: 'Étude thermique RE2020 complète', quantite: 1, prixUnitaire: 9000 },
      { description: 'Attestation de conformité BBIO', quantite: 1, prixUnitaire: 3000 },
      { description: 'Suivi chantier thermique', quantite: 1, prixUnitaire: 3000 },
    ],
  },
  {
    id: 6, numero: 'DEV-2025-006', clientId: 1, ingenieurId: 1, societeId: 2, agenceId: 1,
    sourceTiime: true, tiimeId: 'TIIME-8810',
    designation: 'AMO Structure - Réhabilitation immeuble Haussmannien',
    adresse: '55 La Canebière, 13001 Marseille', ville: 'Marseille',
    montantHT: 18000, statut: 'refuse',
    dateCreation: '2025-01-10', dateEnvoi: '2025-01-12', dateRelance: '2025-01-26', dateValidation: null,
    dateSyncTiime: '2025-01-26T08:00:00',
    echeancier: [
      { pourcentage: 50, label: 'Acompte', montant: 9000 },
      { pourcentage: 50, label: 'Solde', montant: 9000 },
    ],
    codeMission: 'AMO',
    lignes: [
      { description: 'Mission AMO phase conception', quantite: 1, prixUnitaire: 8000 },
      { description: 'Mission AMO phase travaux', quantite: 1, prixUnitaire: 7000 },
      { description: 'Mission AMO phase réception', quantite: 1, prixUnitaire: 3000 },
    ],
  },
  {
    id: 7, numero: 'DEV-2025-007', clientId: 4, ingenieurId: 2, societeId: 1, agenceId: 1,
    sourceTiime: true, tiimeId: 'TIIME-8870',
    designation: 'Accessibilité PMR - Médiathèque centrale',
    adresse: '58 cours Julien, 13006 Marseille', ville: 'Marseille',
    montantHT: 9500, statut: 'accepte',
    dateCreation: '2025-01-25', dateEnvoi: '2025-01-27', dateRelance: null, dateValidation: '2025-02-08',
    dateSyncTiime: '2025-02-08T14:00:00',
    echeancier: [
      { pourcentage: 100, label: 'À la remise du rapport', montant: 9500 },
    ],
    codeMission: 'ACC',
    lignes: [
      { description: 'Audit accessibilité', quantite: 1, prixUnitaire: 4000 },
      { description: 'Schéma directeur PMR', quantite: 1, prixUnitaire: 3500 },
      { description: 'Rapport de conformité', quantite: 1, prixUnitaire: 2000 },
    ],
  },
  {
    id: 8, numero: 'DEV-2025-008', clientId: 7, ingenieurId: 3, societeId: 1, agenceId: 1,
    sourceTiime: true, tiimeId: 'TIIME-8950',
    designation: 'Étude VRD - Aménagement place de la Joliette',
    adresse: 'Place de la Joliette, 13002 Marseille', ville: 'Marseille',
    montantHT: 35000, statut: 'envoye',
    dateCreation: '2025-02-10', dateEnvoi: '2025-02-11', dateRelance: null, dateValidation: null,
    dateSyncTiime: '2025-02-11T09:00:00',
    echeancier: [
      { pourcentage: 30, label: 'Phase AVP', montant: 10500 },
      { pourcentage: 40, label: 'Phase PRO', montant: 14000 },
      { pourcentage: 30, label: 'Phase DET', montant: 10500 },
    ],
    codeMission: 'VRD',
    lignes: [
      { description: 'Études préliminaires et relevés', quantite: 1, prixUnitaire: 7000 },
      { description: 'Avant-projet détaillé', quantite: 1, prixUnitaire: 10000 },
      { description: 'Projet d\'exécution', quantite: 1, prixUnitaire: 12000 },
      { description: 'Direction de l\'exécution des travaux', quantite: 1, prixUnitaire: 6000 },
    ],
  },
];

// --- AFFAIRES ---
export const affaires = [
  {
    id: 1, numero: 'AFF-2025-001', devisId: 1, clientId: 1, ingenieurId: 1, societeId: 2, agenceId: 1,
    designation: 'Diagnostic structure - Résidence Les Pins',
    adresse: '12 allée des Pins, 13008 Marseille', ville: 'Marseille',
    codeMission: 'DIAG', montantHT: 8500,
    montantSousTraitanceExterne: 0, montantSousTraitanceInterne: 0,
    avancement: 75, statut: 'en_cours',
    dateCreation: '2025-02-06', dateDebut: '2025-02-10', dateFin: null,
    echeances: [
      { id: 1, label: 'Acompte à la commande', montant: 4250, moisPrevu: '2025-02', statut: 'facture', factureId: 1 },
      { id: 2, label: 'Solde à la remise du rapport', montant: 4250, moisPrevu: '2025-04', statut: 'a_facturer', factureId: null },
    ],
  },
  {
    id: 2, numero: 'AFF-2025-002', devisId: 2, clientId: 2, ingenieurId: 2, societeId: 1, agenceId: 1,
    designation: 'Contrôle technique - Groupe scolaire Pasteur',
    adresse: 'Rue Pasteur, 13001 Marseille', ville: 'Marseille',
    codeMission: 'CTB', montantHT: 22000,
    montantSousTraitanceExterne: 3500, montantSousTraitanceInterne: 2000,
    avancement: 40, statut: 'en_cours',
    dateCreation: '2025-02-11', dateDebut: '2025-02-15', dateFin: null,
    echeances: [
      { id: 3, label: 'Phase études', montant: 6600, moisPrevu: '2025-03', statut: 'facture', factureId: 2 },
      { id: 4, label: 'Phase chantier', montant: 8800, moisPrevu: '2025-06', statut: 'a_facturer', factureId: null },
      { id: 5, label: 'Réception', montant: 6600, moisPrevu: '2025-09', statut: 'a_facturer', factureId: null },
    ],
  },
  {
    id: 3, numero: 'AFF-2025-003', devisId: 7, clientId: 4, ingenieurId: 2, societeId: 1, agenceId: 1,
    designation: 'Accessibilité PMR - Médiathèque centrale',
    adresse: '58 cours Julien, 13006 Marseille', ville: 'Marseille',
    codeMission: 'ACC', montantHT: 9500,
    montantSousTraitanceExterne: 0, montantSousTraitanceInterne: 1500,
    avancement: 20, statut: 'en_cours',
    dateCreation: '2025-02-09', dateDebut: '2025-02-12', dateFin: null,
    echeances: [
      { id: 6, label: 'À la remise du rapport', montant: 9500, moisPrevu: '2025-05', statut: 'a_facturer', factureId: null },
    ],
  },
  {
    id: 4, numero: 'AFF-2024-018', devisId: null, clientId: 6, ingenieurId: 5, societeId: 2, agenceId: 2,
    designation: 'Étude thermique RT2012 - Bâtiment B',
    adresse: 'ZAC des Milles, 13290 Aix-en-Provence', ville: 'Aix-en-Provence',
    codeMission: 'THER', montantHT: 11000,
    montantSousTraitanceExterne: 2000, montantSousTraitanceInterne: 0,
    avancement: 100, statut: 'terminee',
    dateCreation: '2024-10-15', dateDebut: '2024-10-20', dateFin: '2025-01-20',
    echeances: [
      { id: 7, label: 'Acompte 50%', montant: 5500, moisPrevu: '2024-10', statut: 'paye', factureId: 3 },
      { id: 8, label: 'Solde 50%', montant: 5500, moisPrevu: '2025-01', statut: 'paye', factureId: 4 },
    ],
  },
  {
    id: 5, numero: 'AFF-2024-020', devisId: null, clientId: 3, ingenieurId: 3, societeId: 2, agenceId: 1,
    designation: 'Diagnostic amiante - Tour Méditerranée',
    adresse: '65 avenue Jules Cantini, 13006 Marseille', ville: 'Marseille',
    codeMission: 'DIAG', montantHT: 7200,
    montantSousTraitanceExterne: 1200, montantSousTraitanceInterne: 0,
    avancement: 100, statut: 'terminee',
    dateCreation: '2024-11-01', dateDebut: '2024-11-10', dateFin: '2024-12-20',
    echeances: [
      { id: 9, label: 'Prestation complète', montant: 7200, moisPrevu: '2024-12', statut: 'paye', factureId: 5 },
    ],
  },
  {
    id: 6, numero: 'AFF-2025-004', devisId: null, clientId: 7, ingenieurId: 4, societeId: 1, agenceId: 2,
    designation: 'Étude environnementale - Zone humide de l\'Étang de Berre',
    adresse: 'Bords de l\'Étang de Berre, 13500 Martigues', ville: 'Martigues',
    codeMission: 'ENV', montantHT: 28000,
    montantSousTraitanceExterne: 8000, montantSousTraitanceInterne: 3000,
    avancement: 55, statut: 'en_cours',
    dateCreation: '2025-01-10', dateDebut: '2025-01-20', dateFin: null,
    echeances: [
      { id: 10, label: 'Phase 1 - Diagnostic', montant: 8400, moisPrevu: '2025-02', statut: 'facture', factureId: 6 },
      { id: 11, label: 'Phase 2 - Étude d\'impact', montant: 11200, moisPrevu: '2025-05', statut: 'a_facturer', factureId: null },
      { id: 12, label: 'Phase 3 - Mesures compensatoires', montant: 8400, moisPrevu: '2025-08', statut: 'a_facturer', factureId: null },
    ],
  },
];

// --- FACTURES ---
export const factures = [
  { id: 1, numero: 'FC-2025-001', affaireId: 1, clientId: 1, societeId: 2, agenceId: 1,
    type: 'acompte', montantHT: 4250, tva: 20, montantTTC: 5100,
    dateCreation: '2025-02-10', dateEnvoi: '2025-02-11', dateEcheance: '2025-03-11',
    statut: 'payee', dateRelance: null, datePaiement: '2025-03-05',
    pourcentageAvancement: 50, montantCumuleFacture: 4250 },
  { id: 2, numero: 'FC-2025-002', affaireId: 2, clientId: 2, societeId: 1, agenceId: 1,
    type: 'acompte', montantHT: 6600, tva: 20, montantTTC: 7920,
    dateCreation: '2025-03-01', dateEnvoi: '2025-03-03', dateEcheance: '2025-04-03',
    statut: 'envoyee', dateRelance: null, datePaiement: null,
    pourcentageAvancement: 30, montantCumuleFacture: 6600 },
  { id: 3, numero: 'FC-2024-045', affaireId: 4, clientId: 6, societeId: 2, agenceId: 2,
    type: 'acompte', montantHT: 5500, tva: 20, montantTTC: 6600,
    dateCreation: '2024-10-20', dateEnvoi: '2024-10-21', dateEcheance: '2024-11-21',
    statut: 'payee', dateRelance: null, datePaiement: '2024-11-15',
    pourcentageAvancement: 50, montantCumuleFacture: 5500 },
  { id: 4, numero: 'FC-2025-003', affaireId: 4, clientId: 6, societeId: 2, agenceId: 2,
    type: 'solde', montantHT: 5500, tva: 20, montantTTC: 6600,
    dateCreation: '2025-01-20', dateEnvoi: '2025-01-21', dateEcheance: '2025-02-21',
    statut: 'payee', dateRelance: null, datePaiement: '2025-02-18',
    pourcentageAvancement: 100, montantCumuleFacture: 11000 },
  { id: 5, numero: 'FC-2024-052', affaireId: 5, clientId: 3, societeId: 2, agenceId: 1,
    type: 'solde', montantHT: 7200, tva: 20, montantTTC: 8640,
    dateCreation: '2024-12-20', dateEnvoi: '2024-12-22', dateEcheance: '2025-01-22',
    statut: 'payee', dateRelance: null, datePaiement: '2025-01-18',
    pourcentageAvancement: 100, montantCumuleFacture: 7200 },
  { id: 6, numero: 'FC-2025-004', affaireId: 6, clientId: 7, societeId: 1, agenceId: 2,
    type: 'intermediaire', montantHT: 8400, tva: 20, montantTTC: 10080,
    dateCreation: '2025-02-15', dateEnvoi: '2025-02-16', dateEcheance: '2025-03-16',
    statut: 'en_retard', dateRelance: '2025-03-20', datePaiement: null,
    pourcentageAvancement: 30, montantCumuleFacture: 8400 },
  { id: 7, numero: 'FC-2025-005', affaireId: 1, clientId: 1, societeId: 2, agenceId: 1,
    type: 'solde', montantHT: 4250, tva: 20, montantTTC: 5100,
    dateCreation: '2025-03-15', dateEnvoi: null, dateEcheance: null,
    statut: 'brouillon', dateRelance: null, datePaiement: null,
    pourcentageAvancement: 100, montantCumuleFacture: 8500 },
];

// --- SOUS-TRAITANTS ---
export const sousTraitants = [
  {
    id: 1, nom: 'GEO Fondations Sud', specialite: 'Géotechnique',
    contact: 'Philippe Giraud', email: 'p.giraud@geofondations.fr',
    telephone: '04 91 22 33 44', adresse: '20 rue de la Paix, 13005 Marseille',
    documentsValides: true,
    affaires: [
      { affaireId: 2, montantDevis: 3500, factureNumero: 'GEO-2025-012', montantHT: 3500, montantTTC: 4200, datePaiement: null },
    ],
  },
  {
    id: 2, nom: 'ACOUS Pro Méditerranée', specialite: 'Acoustique',
    contact: 'Catherine Mercier', email: 'c.mercier@acouspro.fr',
    telephone: '04 42 55 66 77', adresse: '5 avenue de l\'Europe, 13100 Aix-en-Provence',
    documentsValides: true,
    affaires: [
      { affaireId: 4, montantDevis: 2000, factureNumero: 'ACOUS-2024-089', montantHT: 2000, montantTTC: 2400, datePaiement: '2025-02-01' },
    ],
  },
  {
    id: 3, nom: 'ENVIRO Études', specialite: 'Environnement',
    contact: 'David Arnaud', email: 'd.arnaud@enviro-etudes.fr',
    telephone: '04 91 88 99 00', adresse: '88 boulevard Rabatau, 13008 Marseille',
    documentsValides: false,
    affaires: [
      { affaireId: 6, montantDevis: 8000, factureNumero: null, montantHT: 0, montantTTC: 0, datePaiement: null },
      { affaireId: 5, montantDevis: 1200, factureNumero: 'ENV-2024-034', montantHT: 1200, montantTTC: 1440, datePaiement: '2025-01-10' },
    ],
  },
  {
    id: 4, nom: 'Structures Béton Armé', specialite: 'Structure béton',
    contact: 'Nicolas Dumont', email: 'n.dumont@sba-ing.fr',
    telephone: '04 91 44 55 66', adresse: '15 rue de la Liberté, 13001 Marseille',
    documentsValides: true, affaires: [],
  },
];

// --- TARIFS PRÉVISITES ---
export const tarifsPrevisite = [
  { zone: 'Marseille', montant: 250 },
  { zone: 'PACA', montant: 350 },
  { zone: 'Hors PACA', montant: 500 },
];

// --- HELPERS SIMPLES ---
export const getClientById = (id) => clients.find(c => c.id === id);
export const getIngenieurById = (id) => ingenieurs.find(i => i.id === id);
export const getSocieteById = (id) => societes.find(s => s.id === id);
export const getAgenceById = (id) => agences.find(a => a.id === id);
export const getDevisById = (id) => devis.find(d => d.id === id);
export const getAffaireById = (id) => affaires.find(a => a.id === id);

// --- HELPERS FILTRÉS PAR SOCIÉTÉ/AGENCE ---
// filters = { societeId, agenceId } — null ou undefined = pas de filtre
export const filterBySocieteAgence = (list, filters = {}) => {
  return list.filter(item => {
    if (filters.societeId && item.societeId !== filters.societeId) return false;
    if (filters.agenceId && item.agenceId !== filters.agenceId) return false;
    return true;
  });
};

export const getFilteredDevis = (filters) => filterBySocieteAgence(devis, filters);
export const getFilteredAffaires = (filters) => filterBySocieteAgence(affaires, filters);
export const getFilteredFactures = (filters) => filterBySocieteAgence(factures, filters);

export const getAffairesByClient = (clientId, filters) => getFilteredAffaires(filters).filter(a => a.clientId === clientId);
export const getDevisByClient = (clientId, filters) => getFilteredDevis(filters).filter(d => d.clientId === clientId);
export const getFacturesByAffaire = (affaireId) => factures.filter(f => f.affaireId === affaireId);
export const getFacturesByClient = (clientId, filters) => getFilteredFactures(filters).filter(f => f.clientId === clientId);
export const getAffairesByIngenieur = (ingenieurId, filters) => getFilteredAffaires(filters).filter(a => a.ingenieurId === ingenieurId);

// Clients filtrés par société
export const getFilteredClients = (filters = {}) => {
  if (!filters.societeId) return clients;
  return clients.filter(c => c.societesIds.includes(filters.societeId));
};

// Production par ingénieur filtrée
export const getProductionIngenieur = (ingenieurId, filters) => {
  const affairesIng = getAffairesByIngenieur(ingenieurId, filters);
  return affairesIng.reduce((acc, a) => ({
    total: acc.total + a.montantHT,
    propre: acc.propre + (a.montantHT - a.montantSousTraitanceExterne - a.montantSousTraitanceInterne),
  }), { total: 0, propre: 0 });
};

// KPIs filtrés par société/agence
export const getKPIs = (filters = {}) => {
  const filteredAff = getFilteredAffaires(filters);
  const filteredDev = getFilteredDevis(filters);
  const filteredFact = getFilteredFactures(filters);

  const productionTotale = filteredAff
    .filter(a => a.dateCreation.startsWith('2025'))
    .reduce((acc, a) => acc + a.montantHT, 0);

  const devisEnAttente = filteredDev
    .filter(d => d.statut === 'envoye')
    .reduce((acc, d) => acc + d.montantHT, 0);

  const devisValides = filteredDev
    .filter(d => d.statut === 'accepte' && d.dateCreation.startsWith('2025'))
    .reduce((acc, d) => acc + d.montantHT, 0);

  const montantFacture = filteredFact
    .filter(f => f.statut === 'payee' && f.dateCreation.startsWith('2025'))
    .reduce((acc, f) => acc + f.montantHT, 0);

  const montantAFacturer = filteredAff
    .filter(a => a.statut === 'en_cours')
    .reduce((acc, a) => {
      const factureAffaire = filteredFact
        .filter(f => f.affaireId === a.id && (f.statut === 'payee' || f.statut === 'envoyee'))
        .reduce((s, f) => s + f.montantHT, 0);
      return acc + (a.montantHT - factureAffaire);
    }, 0);

  const montantSousTraite = filteredAff
    .filter(a => a.dateCreation.startsWith('2025'))
    .reduce((acc, a) => acc + a.montantSousTraitanceExterne, 0);

  const objectifCA = filters.societeId ? 250000 : 500000;

  return {
    productionTotale, objectifCA,
    pourcentageObjectif: Math.round((productionTotale / objectifCA) * 100),
    devisEnAttente, devisValides, montantFacture, montantAFacturer, montantSousTraite,
  };
};

// Info dernière synchro TIIME
export const lastTiimeSync = '2025-02-12T08:30:00';

// Statut labels
export const statutDevisLabels = {
  brouillon: { label: 'Brouillon', color: '#6B7280', bg: '#F3F4F6' },
  envoye: { label: 'Envoyé', color: '#2563EB', bg: '#DBEAFE' },
  accepte: { label: 'Accepté', color: '#059669', bg: '#D1FAE5' },
  refuse: { label: 'Refusé', color: '#DC2626', bg: '#FEE2E2' },
};

export const statutAffaireLabels = {
  en_cours: { label: 'En cours', color: '#2563EB', bg: '#DBEAFE' },
  terminee: { label: 'Terminée', color: '#059669', bg: '#D1FAE5' },
  suspendue: { label: 'Suspendue', color: '#D97706', bg: '#FEF3C7' },
};

export const statutFactureLabels = {
  brouillon: { label: 'Brouillon', color: '#6B7280', bg: '#F3F4F6' },
  envoyee: { label: 'Envoyée', color: '#2563EB', bg: '#DBEAFE' },
  payee: { label: 'Payée', color: '#059669', bg: '#D1FAE5' },
  en_retard: { label: 'En retard', color: '#DC2626', bg: '#FEE2E2' },
};

export const typeFactureLabels = {
  acompte: { label: 'Acompte', color: '#7C3AED', bg: '#EDE9FE' },
  intermediaire: { label: 'Intermédiaire', color: '#D97706', bg: '#FEF3C7' },
  solde: { label: 'Solde', color: '#059669', bg: '#D1FAE5' },
};
